import { LESS_768_MEDIA_QUERY } from '../../../../consts/adaptive';

const button = {
    height: 26,
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '150%',
    textAlign: 'center',
    borderRadius: '4px',
    cursor: 'pointer',

    '& svg': {
        marginRight: 5,
    },
};

export const styles = {
    container: {
        marginTop: 15,
        marginBottom: 11,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    reviewAmount: {
        margin: 0,
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px',
        lineHeight: '150%',
        color: '#313140',
    },
    sortButtons: {
        display: 'flex',
        flexShrink: 0,
    },
    sortButton: {
        background: 'white',
        border: 'none',
        color: '#3D95FB',
        ...button,
    },
    sortButtonActive: {
        border: 'none',
        background: '#E7E7E7',
        color: '#313140',
        ...button,
    },
    descIcon: {
        transform: 'scaleY(-1)',
    },
    mobileFiltersButton: {
        position: 'relative',
        height: 34,
        width: 34,
        background: '#FFFFFF',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        borderRadius: '50%',
        border: 'none',
        cursor: 'pointer',

        ['& > svg']: {
            height: 24,
            width: 24,
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
        }
    },
    reviewAmountFilterBtnWrap: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    [LESS_768_MEDIA_QUERY]: {
        container: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
        },
        reviewAmountFilterBtnWrap: {
            marginBottom: 19
        }

    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
